export default __webpack_public_path__ + "locales/az/ChangePasswordDialog.json?hash=d5982b4c7f143603e7da04507ba8806a";